import { Button } from "@hopper/button";
import React, { useState } from "react";
import { SelectionRequirementsGroup } from "components/flexible_testing/shared/use_selection_requirements_groups";
import CsvExport from "components/flexible_testing/result_details_page/results_header/csv_export/csv_export";

type OpenCsvExportButtonProps = {
  testId: string;
  selectionRequirementsGroups: SelectionRequirementsGroup[];
};

function OpenCsvExportButton({ testId, selectionRequirementsGroups }: OpenCsvExportButtonProps): JSX.Element {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        className="m-xs"
        onClick={() => {
          setIsPanelOpen(true);
        }}
      >
        Export CSV
      </Button>
      <CsvExport
        testId={testId}
        isPanelOpen={isPanelOpen}
        onClose={() => {
          setIsPanelOpen(false);
        }}
        selectionRequirementsGroups={selectionRequirementsGroups}
      />
    </>
  );
}

export default OpenCsvExportButton;
